export default "__VITE_ASSET__CALmAFxN__"